import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function About() {
    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-6 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
                    About ClickBoard
                </h1>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark rounded-[28px] border border-borderLight dark:border-borderDark p-8 md:p-10">

                    {/* INTRO */}
                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        ClickBoard is a fast, secure, and easy-to-use online clipboard tool that allows users to instantly share text between devices without login or installation. It is designed for simplicity and speed, helping users move text like notes, links, or code snippets across devices in seconds.
                    </p>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        In today’s digital world, people frequently switch between multiple devices such as smartphones, laptops, and desktops. However, transferring text between these devices is often inconvenient. Many users rely on email, messaging apps, or cloud tools, which can be slow or require unnecessary steps.
                    </p>

                    {/* WHY */}
                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        That is exactly why we created{" "}
                        <Link to="/" className="text-primary hover:underline">
                            ClickBoard
                        </Link>.
                        Our goal was to build a lightweight and efficient tool that removes complexity and allows anyone to share text instantly using just a simple 6-digit code.
                    </p>

                    {/* HOW */}
                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        With ClickBoard, you can paste text on one device, generate a unique code, and use that code to retrieve your text on another device. The process is quick, secure, and requires no technical knowledge.
                    </p>

                    {/* WHO */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Who We Are
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We are developers and creators focused on building simple and useful web tools that solve real-world problems. Our approach is to create products that are minimal, fast, and accessible to everyone without unnecessary complexity.
                    </p>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        ClickBoard is built using modern web technologies to ensure a smooth experience, strong performance, and reliable data handling for users across different devices.
                    </p>

                    {/* MISSION */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Our Mission
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Our mission is to simplify digital workflows by removing unnecessary friction in everyday tasks. We believe that sharing information should be fast, easy, and secure — without requiring accounts, downloads, or complicated processes.
                    </p>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        ClickBoard aims to provide a reliable platform where users can transfer text instantly while maintaining privacy through features like auto-expiry and one-time access.
                    </p>

                    {/* FEATURES */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        What You Can Do with ClickBoard
                    </h2>

                    <ul className="list-disc ml-6 text-textMain dark:text-textDark space-y-2 mb-6">
                        <li>Share text instantly between devices</li>
                        <li>Transfer code snippets or notes quickly</li>
                        <li>Send links without using messaging apps</li>
                        <li>Use one-time secure sharing for sensitive data</li>
                        <li>Access your text anywhere using a simple code</li>
                    </ul>

                    {/* FUTURE */}
                    <p className="text-textMain dark:text-textDark leading-8">
                        We are continuously working on improving ClickBoard by adding new features and enhancing performance. Our goal is to make it one of the simplest and most useful tools for everyday digital use.
                    </p>

                </div>

                <Footer />

            </div>

        </section>
    );
}